import { SYS_BORDER_RADIUS_MD, SYS_BORDER_RADIUS_SM } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

export const StyledLocationDialog = styled.div`
	.search-container {
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 1em;
		z-index: 2;
		position: relative;
	}

	.suggestions-container {
		position: absolute;
		font-family: AudiType, sans-serif;
		font-size: 14px;
		left: 0;
		right: 0;
		top: 3.4rem;
		z-index: 1;
		padding: 1rem;
		border-radius: ${SYS_BORDER_RADIUS_MD};
		background: ${(props) => props.theme.sys.gradient.elevation.level2.fill};
		color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.default};
		border: 1px solid ${(props) => props.theme.sys.color.elevation.level2.stroke};
		box-shadow: 0 6px 6px 0 ${(props) => props.theme.sys.color.elevation.level2.shadowColor};

		li {
			padding: 10px;
			cursor: default;
		}
	}

	.suggestions-container li:hover,
	.suggestions-container li[aria-selected='true'] {
		background: #555b66ff;
		border-radius: ${SYS_BORDER_RADIUS_SM};
	}
`;
